export const scrollIntoView = (parent, child) => {
    if (!parent || !child) {
        return;
    }
    parent.scrollTop = child.offsetTop;
};